import { useEffect, useState } from "react";
import { useApiClient } from "../api/useApiClient";
import type { EventoHistorial } from "../types/reviewItem";
import { formatFechaHoraUtc } from "../utils/formato";

/**
 * Fila expandible con el historial de la factura (GET /review-items/{id}/historial).
 * [NUEVO 20/10/2026] Mismo patrón que LineasRow: se monta solo cuando la fila
 * padre está expandida, el fetch es on-demand. Solo lectura, rol Contaduría.
 */
export function HistorialRow({ reviewItemId, colSpan }: { reviewItemId: string; colSpan: number }) {
  const api = useApiClient();
  const [eventos, setEventos] = useState<EventoHistorial[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelado = false;
    setEventos(null);
    setError(null);
    api
      .obtenerHistorial(reviewItemId)
      .then((resultado) => {
        if (!cancelado) setEventos(resultado);
      })
      .catch((err) => {
        if (!cancelado) setError(err instanceof Error ? err.message : "Error al cargar el historial.");
      });
    return () => {
      cancelado = true;
    };
  }, [api, reviewItemId]);

  return (
    <tr className="lineas-row">
      <td colSpan={colSpan}>
        {error && <p className="error-text">{error}</p>}
        {!error && eventos === null && <p className="subtitle">Cargando historial...</p>}
        {eventos && eventos.length === 0 && <p className="subtitle">Sin eventos registrados.</p>}
        {eventos && eventos.length > 0 && (
          <table className="lineas-table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Evento</th>
              </tr>
            </thead>
            <tbody>
              {eventos.map((evento, i) => (
                <tr key={i}>
                  <td className="mono">{formatFechaHoraUtc(evento.fecha)}</td>
                  <td className="wrap-ok">{evento.evento}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </td>
    </tr>
  );
}

/** Botón toggle para expandir/contraer el historial. */
export function HistorialToggle({ expanded, onToggle }: { expanded: boolean; onToggle: () => void }) {
  return (
    <button type="button" className="btn-ghost" onClick={onToggle}>
      {expanded ? "▾ Historial" : "▸ Historial"}
    </button>
  );
}
